import benefitsBanner from "../../../assets/images/benefits.jpg";

export const BannerBenefits = ({ data }) => {
  console.log(data);
  return (
    <section
      className="Banner"
      style={{ backgroundImage: `url(${benefitsBanner})` }}
    >
      <div className="ovelay"></div>
      <div className="container position-relative">
        <div className="row">
          <div className="col-md-7 m-auto  d-flex flex-column align-items-center">
            <h1 className="text-white" data-aos="fade-up">
              {data?.name}
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};
